import { render, staticRenderFns } from "./EventTemplates.vue?vue&type=template&id=38d39afe&scoped=true"
import script from "./EventTemplates.vue?vue&type=script&lang=ts"
export * from "./EventTemplates.vue?vue&type=script&lang=ts"
import style0 from "./EventTemplates.vue?vue&type=style&index=0&id=38d39afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d39afe",
  null
  
)

export default component.exports